import IOrder from "../../../models/IOrder";
import IPayment from "../../../models/IPayment";
import PaymentTypesEnum from "../../../models/PaymentTypesEnum";
import HelperService from "../../../services/HelperService";
import UserService from "../../../services/UserService";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwPill from "../../shared/OwPill/OwPill";

type Props = {
    order: IOrder;
};

export const OrderEntryPaymentsPanel = (props: Props) => {
    const paymentTypeKey = (paymentTypeId: number | null | undefined): string => {
        switch (paymentTypeId) {
            case PaymentTypesEnum.CREDIT_CARD:
                return "credit_card";
            case PaymentTypesEnum.CASH:
                return "cash";
            case PaymentTypesEnum.CHECK:
                return "check";
            case PaymentTypesEnum.TERMS:
                return "net_terms";
            case PaymentTypesEnum.SALES_REP:
                return "sales_rep";
            default:
                return "payment";
        }
    };

    const getStatusPill = (payment: IPayment) => {
        if (payment.is_voided) {
            return <OwPill title={"voided"} className={"ps-2 pe-2 bg-danger"} />;
        }

        if (payment.is_refund) {
            return <OwPill title={"refunded"} className={"ps-2 pe-2 bg-info"} />;
        }

        if (payment.is_captured) {
            return <OwPill title={"captured"} className={"ps-2 pe-2 bg-success"} />;
        }

        return <OwPill title={"authorized"} className={"ps-2 pe-2"} />;
    };

    const getPaymentRow = (payment: IPayment) => {
        const amount = HelperService.formatCurrency({ value: payment.capture_amount ?? payment.auth_amount });

        const receivedAt = UserService.parseLastUpdated(payment.received_at || payment.created_at, true);

        return (
            <div key={payment.guid} className={"border border-dark-subtle border-1 rounded p-2 mb-2"}>
                <div className={"d-flex align-items-center"}>
                    <b>
                        <OwLabel title={paymentTypeKey(payment.payment_type_id)} className={"me-2"} />
                    </b>
                    <b className={"me-2"}>{amount}</b>
                    {getStatusPill(payment)}
                    {payment.reference ? (
                        <div className={"ps-2 pe-2 ms-2 border border-dark-subtle border-1 rounded-5 text-small"}>
                            <b>{payment.reference}</b>
                        </div>
                    ) : null}
                </div>
                <div className={"text-small text-muted"}>{receivedAt}</div>
            </div>
        );
    };

    return (
        <div className={"OrderEntryPaymentsPanel"}>
            <div className="panel panel-default p-2">
                <div className="panel-body">
                    {props.order.Payments?.map((payment) => {
                        return getPaymentRow(payment);
                    })}
                    {!props.order.Payments?.length && (
                        <div className="">
                            <OwLabel title={"no_payments_found"} />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
